<template>
  <div class="intro">
    <SideMenu></SideMenu>
    <div v-if="displayName">Welcome <span v-if="!this.$store.state.progress.welcome">back </span>{{ displayName }}</div>
        <p>This is the other part of</p>
        <p class="title is-4">These Pages Fall Like Ash</p>

        <p>The physical book is your guide to the space around you, so keep it with you; it contains a voice from another place.</p>

        <p>We will ask you to walk during this story.</p>

        <p>Walk, and imagine.</p>
      <button class="button is-fullwidth-mobile" @click="nextPage()">{{ beginCont }}</button>
  </div>
</template>
<script>
export default {
  name: 'Intro',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    displayName () {
      if (this.$store.state.user.displayName) {
        return this.$store.state.user.displayName
      } else {
        return null
      }
    },
    beginCont () {
      if (this.$store.state.progress.welcome) {
        return 'Begin'
      } else if (this.$root.progress.finished) {
        return 'Contents'
      } else {
        return 'Continue'
      }
    }
  },
  methods: {
    nextPage () {
      // Ep and Chap progress are updated when it is completed so navigation is +1 to current progress
      if (!this.$store.state.progress.finished) {
        this.$router.push({
          name: 'Location',
          params: {
            episode: this.$root.progress.episode,
            chapter: this.$root.progress.chapter
          }
        })
      } else {
        this.$router.push({ name: 'Contents' })
      }
    },
    getPermission () {
      // Request Permission of Notifications
      Notification.requestPermission().then(() => {
        console.log(Notification.permission)
      }).catch((err) => {
        console.log('Unable to get permission to notify.', err)
      })
    },
    sendNotif () {
      setTimeout(function () {
        navigator.serviceWorker.getRegistration()
          .then((reg) => reg.showNotification('These Pages Fall Like Ash', {
            body: 'Hello World',
            vibrate: [400, 100, 200],
            data: {
              url: window.location.href // pass the current url to the notification
            },
            actions: [
              {
                action: 'open',
                title: 'Open app'
              },
              {
                action: 'close',
                title: 'Close notification'
              }
            ],
            badge: './img/ionic.png',
            icon: './img/ionic.png'
          }))
      }, 3000)
    },
    alertify () {
      this.$alertify.confirm('new alert!', () => {
        console.log(this.$alertify.elements)
      })
    }
  }
}
</script>
